<template>
  <div>
    <div class="bg-blue-900 p-4 lg:p-12">
      <div class="max-w-5xl mx-auto mb-12">
        <div class="flex flex-col md:flex-row md:items-center">
          <h4 class="text-white font-bold">Clients</h4>
        </div>
      </div>
    </div>
    <div class="px-4 pb-4 lg:px-12 lg:pb-12 -mt-12">
      <div class="max-w-5xl mx-auto">
        <div>
          <VList :meta="meta" searchable>
            <template v-if="loading" #default>
              <div class="odd:bg-gray-100 border border-gray-200 rounded p-4 text-center">
                <Loader />
              </div>
            </template>

            <template v-else-if="accounts.length" #default>
              <template v-for="account in accounts">
                <VListLine :key="account.id" :account="account" />
              </template>
            </template>

            <template v-else #default>
              <div class="odd:bg-gray-100 border border-gray-200 rounded p-4 text-center">
                No results found
              </div>
            </template>
          </VList>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VListLine from '@/components/Client/ClientListLine.vue';
import VList from '@/components/Common/VList.vue';

export default {
  name: 'ClientsView',

  components: {
    VList,
    VListLine,
  },

  data() {
    return {
      loading: false,
    };
  },

  computed: {
    accounts() {
      return this.$store.getters['ui/clients/clients'];
    },
    meta() {
      return this.$store.state.ui.clients.meta;
    },
  },

  watch: {
    $route: 'fetchData',
  },

  created() {
    this.init();
  },

  destroyed() {
    this.$store.commit('ui/clients/setIds', []);
    this.$store.commit('ui/clients/setMeta', null);
    this.$store.commit('ui/clients/setLinks', null);
  },

  methods: {
    async init() {
      try {
        await this.fetchData();
      } catch (error) {
        /** handle error */
      } finally {
        this.initialized = true;
      }
    },
    async fetchData() {
      if (this.loading) return;

      const { query: params } = this.$route;

      this.loading = true;

      try {
        await this.$store.dispatch('ui/accounts/getAccounts', { params });
      } catch (error) {
        //
      }

      this.loading = false;
    },
  },
};
</script>
